import React from 'react';

export function useModal(initialValue = false) {
   const [open, setOpen] = React.useState(initialValue);
   const handleOpen = React.useCallback(() => setOpen(true), []);
   const handleClose = React.useCallback(() => setOpen(false), []);
   return {open, handleOpen, handleClose};
}
